import i18n from "../i18n";

const loc = () => (i18n.language?.startsWith("ru") ? "ru-RU" : "en-GB");

export function fmtDate(value, precision = "day") {
  if (!value) return "—";
  const s = String(value);
  if (precision === "year" || /^\d{4}$/.test(s)) return i18n.t("date.approx", { date: s.slice(0, 4) });
  if (precision === "month" || /^\d{4}-\d{2}$/.test(s)) {
    const d = new Date(`${s.slice(0, 7)}-15T12:00:00Z`);
    return i18n.t("date.approx", { date: new Intl.DateTimeFormat(loc(), { month: "long", year: "numeric", timeZone: "UTC" }).format(d) });
  }
  const d = s.length <= 10 ? new Date(`${s}T12:00:00Z`) : new Date(s);
  if (isNaN(d)) return s;
  return new Intl.DateTimeFormat(loc(), { day: "numeric", month: "long", year: "numeric", timeZone: s.length <= 10 ? "UTC" : undefined }).format(d);
}

export function fmtDateTime(isoStr, tz) {
  if (!isoStr) return "—";
  const d = new Date(isoStr);
  if (isNaN(d)) return isoStr;
  const zone = tz || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const txt = new Intl.DateTimeFormat(loc(), { day: "numeric", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: zone }).format(d);
  return `${txt} (${zone})`;
}

export function fmtLocal(local, tz) {
  if (!local) return "—";
  const [date, time] = local.split("T");
  return `${fmtDate(date)}, ${time || ""} (${tz})`;
}

export const todayISO = () => new Date().toISOString().slice(0, 10);
